import React from 'react';
import {
  SolutionPremiumContent,
  SolutionSubPageLayout,
  getSolutionSubpage,
} from '../features/solutions';

export const SmartManufacturing: React.FC = () => {
  const config = getSolutionSubpage('smart-manufacturing');
  return (
    <SolutionSubPageLayout config={config}>
      <SolutionPremiumContent config={config} />
    </SolutionSubPageLayout>
  );
};
